import { api, type CommandRow } from "../api";
import { useApiData } from "../useApi";
import { CommandState, PageState, formatTime } from "../components";

export function Commands({ onSignedOut }: { onSignedOut: () => void }) {
  const { data, error, loading, reload } = useApiData(() => api.commands(100), onSignedOut);

  const unresolved = data?.commands.filter((c) => c.state === "UNKNOWN") ?? [];

  return (
    <>
      <h1>Commands</h1>
      <p className="subtitle">
        Every order command and what the broker actually did with it.{" "}
        <button className="link" onClick={reload}>
          Refresh
        </button>
      </p>

      {unresolved.length > 0 && (
        <div className="notice error">
          {unresolved.length} command(s) in UNKNOWN: the broker outcome could not be
          confirmed. These need reconciliation — they are never retried automatically.
        </div>
      )}

      <PageState
        loading={loading}
        error={error}
        empty={data?.commands.length === 0}
        emptyMessage="No commands have been issued yet."
      >
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>State</th>
                <th>Action</th>
                <th>Symbol</th>
                <th>Side</th>
                <th>Volume</th>
                <th>Fill</th>
                <th>Ticket</th>
                <th>Created</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {data?.commands.map((command) => (
                <Row key={command.command_id} command={command} />
              ))}
            </tbody>
          </table>
        </div>
      </PageState>
    </>
  );
}

function Row({ command }: { command: CommandRow }) {
  const result = command.result ?? {};
  const retcode = result.broker_retcode as string | undefined;

  return (
    <tr>
      <td className="mono dim">{command.sequence}</td>
      <td>
        <CommandState state={command.state} />
      </td>
      <td>{command.action ?? "—"}</td>
      <td>{command.provider_symbol ?? "—"}</td>
      <td>{command.side === "NONE" ? "—" : (command.side ?? "—")}</td>
      <td className="mono">{command.volume ?? "—"}</td>
      <td className="mono">{(result.fill_price as string) ?? "—"}</td>
      <td className="mono dim">{(result.ticket as string) ?? "—"}</td>
      <td className="dim">{formatTime(command.created_at)}</td>
      <td>
        <details>
          <summary>detail</summary>
          <pre>
            {JSON.stringify(
              {
                command_id: command.command_id,
                account_ref: command.account_ref,
                environment: command.environment,
                delivered_to: command.delivered_to_ea_instance_id,
                acknowledged_at: command.acknowledged_at,
                expires_at: command.expires_at,
                broker_retcode: retcode ?? null,
                result: command.result,
              },
              null,
              2,
            )}
          </pre>
        </details>
      </td>
    </tr>
  );
}
